var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"empty"},[(_vm.icon)?_c('Icon',{staticClass:"empty__icon"},[_vm._v(_vm._s(_vm.icon))]):_vm._e(),_c('h4',{staticClass:"empty__title"},[_vm._t("default")],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }